'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

const FormieSubmitRow = ({ isSuccess, isError, isLoading, messages })=>{
    const showLoading = isLoading;
    const showErrors = isError && !isLoading;
    const spacing = 4;
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(material.Collapse, {
                in: showErrors,
                unmountOnExit: true,
                children: /*#__PURE__*/ jsxRuntime.jsx(material.Alert, {
                    severity: "error",
                    sx: {
                        mb: spacing
                    },
                    children: /*#__PURE__*/ jsxRuntime.jsx(material.Typography, {
                        dangerouslySetInnerHTML: {
                            __html: messages.error
                        }
                    })
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.Collapse, {
                in: isSuccess,
                unmountOnExit: true,
                children: /*#__PURE__*/ jsxRuntime.jsx(material.Alert, {
                    severity: "success",
                    sx: {
                        mb: spacing
                    },
                    children: /*#__PURE__*/ jsxRuntime.jsx(material.Typography, {
                        dangerouslySetInnerHTML: {
                            __html: messages.success
                        }
                    })
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs(material.Stack, {
                flexDirection: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(material.Button, {
                        type: "submit",
                        size: "large",
                        disabled: isLoading,
                        variant: "contained",
                        children: "Submit"
                    }),
                    showLoading && /*#__PURE__*/ jsxRuntime.jsx(material.CircularProgress, {
                        color: "inherit",
                        size: 40
                    })
                ]
            })
        ]
    });
};

module.exports = FormieSubmitRow;
